//config
export * from './tasks-config'

// Storico dell'ordine e rotta del task, usati anche dal dettaglio ordine
export { TASKS_DESCRIBE } from './lib/constants'
export { TaskDetailService } from './lib/services/task-detail.service'
export type { TaskHistoryStep } from './lib/task-detail/task-detail.model'
export type { OrderActivity, OrderActivityChange } from './interfaces/order-activity.model'
export { historyFromActivities } from './utils/task-history.utils'
export { taskAnomalies } from './utils/task.utils'
